var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_621_11967)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 38,
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_621_11967)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_621_11967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.25132 93.3345C-34.5274 38.4363 12.8346 -26.8981 101.535 -52.5939C190.235 -78.2896 353.703 59.3755 383.979 114.274C414.255 169.172 262.436 50.4134 173.736 76.1092C85.0363 101.805 26.0248 148.233 -4.25132 93.3345Z",
    fill: "#57249C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_621_11967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.042 112.007C31.2896 149.395 7.15133 170.131 -34.5592 184.684C-119.057 214.166 -16.3506 -78.5242 36.2647 -17.1482C69.4397 21.5506 73.9946 64.2511 50.042 112.007Z",
    fill: "#00FFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_621_11967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.788 217.471C222.614 189.955 222.528 169.972 234.371 138.688C257.231 78.2994 233.168 40.5792 261.414 -18.9621C319.05 -140.452 469.363 225.525 308.034 301.787C206.618 349.728 -100.232 375.232 -12.1131 317.663C23.0786 294.672 58.7369 295.147 99.0674 275.854C140.69 255.944 168.413 245.552 195.788 217.471Z",
    fill: "#EB3366"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.73,
    filter: "url(#filter4_f_621_11967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.101 220.522C224.714 210.66 224.684 203.499 228.928 192.287C237.121 170.645 228.497 157.127 238.62 135.788C259.276 92.2481 313.145 223.408 255.328 250.739C218.982 267.92 109.012 277.06 140.592 256.429C153.204 248.189 165.984 248.359 180.438 241.445C195.354 234.31 205.29 230.586 215.101 220.522Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M197.67 167.569C193.45 170.996 187.275 172.931 179.727 172.931C172.178 172.931 165.911 170.996 161.658 167.569C157.622 164.327 155.35 159.735 155.35 154.181C155.35 142.795 164.921 135.43 179.727 135.43C194.532 135.43 203.929 142.795 203.929 154.181C203.929 159.727 201.673 164.318 197.67 167.569ZM179.727 81.8846C192.851 81.8846 201.665 88.9223 201.665 99.4035C201.665 109.885 192.851 117.098 179.727 117.098C166.602 117.098 157.613 110.153 157.613 99.4035C157.613 88.6542 166.502 81.8846 179.727 81.8846ZM214.282 130.043C212.085 128.183 210.046 126.767 207.923 125.678C211.71 123.231 214.731 120.366 217.17 116.931C220.948 111.51 222.854 105.134 222.854 97.9876C222.854 77.0587 205.527 63 179.735 63C153.943 63 136.433 77.0587 136.433 97.9876C136.433 105.134 138.347 111.51 142.125 116.939C144.58 120.408 147.701 123.298 151.388 125.552C146.852 128.133 143.032 131.383 140.045 135.237C135.684 141.035 133.47 147.947 133.47 155.781C133.47 160.003 134.177 163.958 135.525 167.586C141.06 182.566 157.455 192 179.735 192C202.014 192 218.168 182.399 223.861 167.586C225.259 163.95 226 159.995 226 155.781C226 145.584 221.955 136.695 214.29 130.051",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.261 81.5285C88.3869 81.5285 97.2012 88.4335 97.2012 98.7171C97.2012 109.001 88.3869 116.078 75.261 116.078C62.1351 116.078 53.1459 109.264 53.1459 98.7171C53.1459 88.1705 62.0352 81.5285 75.261 81.5285ZM109.819 128.779C107.622 126.954 105.583 125.564 103.46 124.496C107.247 122.096 110.269 119.284 112.708 115.914C116.486 110.595 118.392 104.34 118.392 97.3279C118.392 76.7936 101.063 63 75.2693 63C49.4754 63 31.9631 76.7936 31.9631 97.3279C31.9631 104.34 33.8775 110.595 37.6562 115.922C40.1116 119.325 43.2329 122.161 46.9201 124.373C42.3839 126.904 38.5635 130.094 35.5754 133.875C31.214 139.564 29 146.345 29 154.031C29 158.174 29.7075 162.054 31.0559 165.614H57.1994C53.1626 162.432 50.8903 157.928 50.8903 152.478C50.8903 141.306 60.4621 134.081 75.2693 134.081C90.0765 134.081 99.4735 141.306 99.4735 152.478C99.4735 157.919 97.2179 162.424 93.2061 165.614H119.391C120.79 162.046 121.53 158.166 121.53 154.031C121.53 144.027 117.485 135.305 109.819 128.787",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_621_11967",
    x: -130.142,
    y: -119.164,
    width: 581.458,
    height: 369.349,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.7036,
    result: "effect1_foregroundBlur_621_11967"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_621_11967",
    x: -94.3355,
    y: -136.697,
    width: 563.184,
    height: 346.579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40.47,
    result: "effect1_foregroundBlur_621_11967"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_621_11967",
    x: -147.675,
    y: -106.574,
    width: 293.742,
    height: 374.291,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40.47,
    result: "effect1_foregroundBlur_621_11967"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_621_11967",
    x: -134.666,
    y: -150.304,
    width: 621.98,
    height: 607.91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 53.4233,
    result: "effect1_foregroundBlur_621_11967"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_621_11967",
    x: 96.6714,
    y: 88.7174,
    width: 222.907,
    height: 217.865,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.146,
    result: "effect1_foregroundBlur_621_11967"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_621_11967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1b4fc3ec8203580e600a990599f3dae8.svg";
export { ForwardRef as ReactComponent };